import styled from 'styled-components'

import { Link } from 'pcln-design-system'

const StyledLink = styled(Link)`
  text-decoration: none !important;
`

StyledLink.displayName = 'StyledLink'

export default StyledLink
